
import Vue, { PropType } from "vue";
import { Alert, ToiletType } from "@/models";

export default Vue.extend({
  name: "AlertLongStayListItem",

  props: {
    alert: Object as PropType<Alert>,
  },

  computed: {
    floorPlanUrl(): string | undefined {
      return this.alert.floorPlanUrl;
    },
    alertTypeText(): string {
      const type = this.alert.alertType;
      if (type === undefined) {
          return "不明";
      }
      return type;
    },
    alertTypeClassText(): string {
      switch (this.alert.alertType) {
        case "長時間利用":
          return "red";
        default:
          return "red";
      }
    },

    toiletTypeText(): string {
      switch (this.alert?.kind) {
        case ToiletType.FOR_MAN:
          return "男性トイレ";
        case ToiletType.FOR_WOMAN:
          return "女性トイレ";
        case ToiletType.UNISEX:
          return "共用";
        case ToiletType.MULTI_PURPOSE:
          return "多目的トイレ";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.alert?.status) {
        case "発生":
          return "red";
        case "解決済":
          return "resolved";
        default:
          return "";
      }
    },
    statusText(): string {
      switch (this.alert?.status) {
        case "発生":
          return "発生";
        case "解決済":
          return "解決済";
        default:
          return "";
      }
    },
  },
});
